import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import HeaderAdmin from './HeaderAdmin';

const Admin = () => {
  return (
    <>
      <Container fluid>
        <Row>
          <HeaderAdmin />
        </Row>

        <Row>
          <Col>
            <div className="h1 mt-1 mb-2">Welcome, Admin!</div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Admin;
